import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from './locales/en.json'
import he from './locales/he.json'
import hi from './locales/hi.json'
import id from './locales/id.json'
import ms from './locales/ms.json'

const resources = {
  en: { translation: en },
  he: { translation: he },
  hi: { translation: hi },
  id: { translation: id },
  ms: { translation: ms },
}

// Detect language from URL path: /en/... or /he/...
function getLangFromPath(): string | undefined {
  const match = window.location.pathname.match(/^\/(en|he|hi|id|ms)(\/|$)/)
  return match ? match[1] : undefined
}

const pathLang = getLangFromPath()

const languageDetector = new LanguageDetector()
languageDetector.addDetector({
  name: 'path',
  lookup() {
    return getLangFromPath()
  },
})

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'he',
    supportedLngs: ['en', 'he', 'hi', 'id', 'ms'],
    // If URL has a lang prefix, use it directly
    ...(pathLang ? { lng: pathLang } : {}),

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      order: ['path', 'localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'language',
    },
  })

// Helper to get RTL status
export const isRtlLanguage = (lang: string): boolean => {
  return lang === 'he'
}

// Update document direction when language changes
i18n.on('languageChanged', (lng) => {
  const dir = isRtlLanguage(lng) ? 'rtl' : 'ltr'
  document.documentElement.dir = dir
  document.documentElement.lang = lng
})

// Set initial direction
const initialDir = isRtlLanguage(i18n.language) ? 'rtl' : 'ltr'
document.documentElement.dir = initialDir
document.documentElement.lang = i18n.language

export default i18n
